/* eslint-disable @typescript-eslint/naming-convention */
import { Link, useParams } from 'react-router-dom'

import Icon from './Icon'

import { iconForOrgType } from '../utils/utils' 

import { currentBusinessEntitySignal, businessEntitiesLoadedSignal } from '../state/signals/businessEntitySignals.js'
import { currentUrlFragmentSignal } from '../state/signals/userSettingsSignals.js'

const BusinessEntityTreeElement = function ({ businessEntity, depth, expandedBusinessEntitiesSetSignal, expandedSearchOverrideSetSignal, expandAllSignal, rerender, hiddenBusinessEntitiesSetSignal }) {

    const { beId } = useParams()

    const getCaretIcon = (element) => {
        if (element.companies && element.companies.length > 0) {
            if (true == expandedSearchOverrideSetSignal.value?.has(element.id)) {
                return 'blank'
            }
            // caret
            if (isExpanded(element.id)) {
                return 'caret-down-fill'
            }
            return 'caret-right-fill'
        }
        return 'blank'
    }

    const Children = function (children) {
        let elements = []
        for (let i = 0; i < children.length; i++) {

            elements.push(
                <BusinessEntityTreeElement
                    businessEntity={children[i]}
                    depth={depth + 1}
                    expandedBusinessEntitiesSetSignal={expandedBusinessEntitiesSetSignal}
                    expandedSearchOverrideSetSignal={expandedSearchOverrideSetSignal}
                    expandAllSignal={expandAllSignal}
                    rerender={rerender}
                    childNum={i + 1}
                    key={children[i].id}
                    hiddenBusinessEntitiesSetSignal={hiddenBusinessEntitiesSetSignal}
                ></BusinessEntityTreeElement>
            )
        }
        return elements
    }

    const isExpanded = (beid) => {
        if (expandAllSignal.value) {
            //console.log("Expand all is checked")
            return true
        }
        else if (true == expandedSearchOverrideSetSignal.value?.has(beid)) {
            //console.log(`BE ID ${beid} is a search term, or its child is`)
            return true
        }
        else if (expandedBusinessEntitiesSetSignal.value?.has(beid)) {
            //console.log("BEID ".concat(beid).concat(" is in the expanded set"))
            return true
        }
        else {
            //console.log("Expand all is not checked, and BEID ".concat(beid).concat(" is not in the expanded set"))
            return false
        }
    }

    const toggleExpansion = function (beid) {
        if (expandAllSignal && expandAllSignal.value) {
            //console.log("Expand all is checked, returning early")
            return
        }
        if (expandedBusinessEntitiesSetSignal.value.has(beid)) {
            //console.log("BEID ".concat(beid).concat(" is already in the expanded set, removing it now"))
            expandedBusinessEntitiesSetSignal.value.delete(beid)
        }
        else {
            //console.log("BEID ".concat(beid).concat(" is not in the expanded set, adding it now"))
            expandedBusinessEntitiesSetSignal.value.add(beid)
        }
        const set = expandedBusinessEntitiesSetSignal.value
        expandedBusinessEntitiesSetSignal.value = null
        expandedBusinessEntitiesSetSignal.value = set
        rerender()
    }

    if (!businessEntitiesLoadedSignal.value) {
        //console.log("No, business entities have not been loaded")
        return <></>
    }

    return (
        <>
            <li /*role="treeitem" aria-expanded="true" aria-setsize="187" aria-posinset={childNum} aria-level="2" aria-disabled="false"*/ className="tree-branch-wrapper" key={businessEntity?.id} data-key={businessEntity?.id} hidden={businessEntity?.id != null && hiddenBusinessEntitiesSetSignal.value?.has(businessEntity?.id) ? true : undefined}>
                <div style={{ paddingLeft: 20 * (depth) }} className={`d-block text-truncate text-nowrap`}>
                    <span className="ml-1" onClick={
                        () => {
                            //console.log("inside the onClick function")
                            toggleExpansion(businessEntity?.id)
                        }
                    }>
                            <Icon
                            icon={getCaretIcon(businessEntity)}
                            width={16}
                            height={16}
                        ></Icon>
                        &nbsp;
                    </span>
                    <Icon icon={iconForOrgType(businessEntity)} height={16} width={16}></Icon>
                    <span className={`mx-1 px-1 ${businessEntity?.id == currentBusinessEntitySignal.value.id ? 'bg-primary-subtle text-black' : ''}`}>
                        <Link to={`/be/${businessEntity?.id}/${currentUrlFragmentSignal.value}`}>{businessEntity?.name} </Link>
                    </span>
                </div>
                {
                    (isExpanded(businessEntity?.id) && businessEntity?.companies && businessEntity?.companies.length) ? (
                        <ul role="group" className="tree-node-group tree-node-group--expanded tree-node-group--selected">
                            {Children(businessEntity?.companies)}
                        </ul>
                    ) : ''
                }
            </li>
        </>
    )
}
export default BusinessEntityTreeElement